module.exports = __webpack_public_path__ + "media/images/shared/logo_savorjapan_color-b9a3bae8efba2b549cb6ff0bb1060285.png";